module.exports = __webpack_public_path__ + "static/media/undraw-celebration-0-jvk.83b55ebc.svg";